/* eslint-disable */
/**
 * @param {string} btnSelector
 * @param {string} itemSelector
 */
export function initCategoryFilter(btnSelector, itemSelector) {
	const buttons = document.querySelectorAll(btnSelector);
	const items = document.querySelectorAll(itemSelector);

	if (buttons.length === 0) return;

	function handleFilter(clickedBtn) {
		// 1. Reset nút
		buttons.forEach((btn) => {
			btn.classList.remove("bg-primary-500", "text-white");
			btn.classList.add("text-gray-600", "hover:bg-primary-100");
		});

		// 2. Active nút
		clickedBtn.classList.remove("text-gray-600", "hover:bg-primary-100");
		clickedBtn.classList.add("bg-primary-500");

		// 3. Lọc Item
		const filterValue = clickedBtn.getAttribute("data-filter");

		items.forEach((item) => {
			const itemCategory = item.getAttribute("data-category");
			if (filterValue === "all" || itemCategory === filterValue) {
				item.classList.remove("hidden");
				item.classList.add("flex");
			} else {
				item.classList.add("hidden");
				item.classList.remove("flex");
			}
		});
	}

	// Gán sự kiện
	buttons.forEach((btn) => {
		btn.addEventListener("click", function (e) {
			e.preventDefault();
			handleFilter(this);
		});
	});

	// Auto click nút đầu tiên
	if (buttons.length > 0) {
		handleFilter(buttons[0]);
	}
}
